/**
 * Mobil menü drawer — scroll konumundan bağımsız viewport-fixed açılış.
 */
(function () {
  const DETAILS_ID = 'Details-menu-drawer-container';

  function getHeaderBottom() {
    const header = document.querySelector('.section-header');
    if (!header) return 0;
    const wrapper = header.querySelector('.header-wrapper');
    const borderOffset = wrapper?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom - borderOffset));
  }

  function syncDrawerVars() {
    document.documentElement.style.setProperty('--header-bottom-position', `${getHeaderBottom()}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  function resetDrawerScroll(drawer) {
    const nav = drawer?.querySelector('.menu-drawer__navigation-container');
    if (nav) nav.scrollTop = 0;
  }

  function closeNestedDetails(container) {
    container?.querySelectorAll('.menu-drawer details[open]').forEach((el) => {
      if (el.id !== DETAILS_ID) el.removeAttribute('open');
    });
  }

  function init() {
    const root = document.getElementById(DETAILS_ID);
    if (!root) return;

    root.addEventListener('toggle', () => {
      if (root.open) {
        syncDrawerVars();
        resetDrawerScroll(root.querySelector('.menu-drawer'));
      } else {
        closeNestedDetails(root);
      }
    });

    window.addEventListener('resize', syncDrawerVars, { passive: true });
    window.addEventListener('scroll', () => {
      if (root.open) syncDrawerVars();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
